import React from 'react'

export const themes = {
  diag: {
    primary: 'purple',
    primaryColor: '#81439c',
    logoUrl: '/themes/diag/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_dt.svg',
    title: 'Диагностическое интернет-тестирование студентов первого курса',
    href: 'diag'
  },
  fepo: {
    primary: 'green',
    primaryColor: '#049842',
    logoUrl: '/themes/fepo/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_fepo.svg',
    title: 'Федеральный интернет-экзамен в сфере профессионального образования (ФЭПО)',
    href: 'fepo'
  },
  fepo_pro: {
    primary: 'green',
    primaryColor: '#26aa86',
    logoUrl: 'themes/defaultNiimko/images/fepo_pro/logo.svg',
    christmasUrl: '/themes/christmas/logo_fepo_pro.svg?new',
    title: 'Сертификационный экзамен ФЭПО-pro',
    href: 'fepo'
  },
  test_constructor: {
    primary: 'blue',
    primaryColor: '#2d529c',
    logoUrl: 'themes/defaultNiimko/images/test_constructor/logo.svg?ai',
    christmasUrl: '/themes/christmas/logo_TK.svg',
    title: 'Тест-Конструктор с нейросетями',
    href: 'training'
  },
  ias: {
    primary: 'blue',
    primaryColor: '#1b77d2',
    logoUrl: '/themes/training/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_it.svg',
    title: 'Интернет-тренажеры в сфере образования',
    href: 'training'
  },
  training: {
    primary: 'blue',
    primaryColor: '#1b77d2',
    logoUrl: '/themes/training/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_it.svg',
    title: 'Интернет-тренажеры в сфере образования',
    href: 'training'
  },
  olymp: {
    primary: 'orange',
    primaryColor: '#f67e04',
    logoUrl: '/themes/olymp/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_olymp.svg',
    title: 'Интернет-олимпиады',
    href: 'olymp'
  },
  olymp_en: {
    primary: 'orange',
    primaryColor: '#f67e04',
    logoUrl: '/themes/olymp_en/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_olymp.svg',
    title: 'Internet-Olympiads',
    href: 'olymp-en'
  },
  olps: {
    primary: 'orange',
    primaryColor: '#f67e04',
    logoUrl: '/themes/olymp/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_olymp.svg',
    title: 'Интернет-олимпиады (междисциплинарные)',
    href: 'olymp'
  },
  fieb: {
    primary: 'pink',
    primaryColor: '#bd3054',
    logoUrl: '/themes/bakalavr/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_fieb.svg',
    title: 'Федеральный интернет-экзамен для выпускников бакалавриата и специалитета (ФИЭБ)',
    href: 'bakalavr'
  },
  tfieb: {
    primary: 'red',
    primaryColor: '#812136',
    logoUrl: '/themes/tfieb/images/logo.svg',
    christmasUrl: '/themes/christmas/logo_tfieb.svg',
    title: 'Тренажер ФИЭБ',
    href: 'tfieb'
  },
  default: {
    primary: 'blue',
    primaryColor: '#009846',
    logoUrl: '/themes/defaultNiimko/images/new/main_logo.svg?new',
    christmasUrl: '/themes/christmas/main_logo.svg',
    title: 'Единый портал интернет-тестирования в сфере образования',
    href: ''
  }
}

const ThemeContext = React.createContext(themes.default)

export default ThemeContext
